export enum SubscriptionStatus {
  ACTIVE = 'Active',
  CANCELED = 'Cancelled',
  FUTURE = 'Future',
  IN_TRIAL = 'InTrial',
  NON_RENEWING = 'NonRenewing',
  PAUSED = 'Paused',
  UNKOWN = 'UnKnown',
}
